import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material';
import { ReactNode } from 'react';
import Icon from '../../IconSvg/Icon';
import { LelyIconName } from '../buttonTypes';

type LelyIconButtonSize = 'sm' | 'md' | 'lg' | 'xl';

const lelyIconButtonSizes: Record<LelyIconButtonSize, string> = {
  sm: '16px',
  md: '18px',
  lg: '20px',
  xl: '24px',
};

export type LelyIconButtonProps = Omit<MuiIconButtonProps, 'size'> & {
  'data-testid'?: string;
  size?: LelyIconButtonSize;
  icon?: LelyIconName | ReactNode;
};

function LelyIconButton({
  size = 'xl',
  icon,
  'data-testid': dataTestId,
  children,
  sx,
  ...props
}: LelyIconButtonProps) {
  const iconButtonSize = lelyIconButtonSizes[size];
  const iconButtonSx = [
    {
      padding: 0,
      width: iconButtonSize,
      height: iconButtonSize,
      minWidth: iconButtonSize,
      minHeight: iconButtonSize,

      '& .icon-svg, & .MuiSvgIcon-root': {
        width: iconButtonSize,
        height: iconButtonSize,
      },
    },
    ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
  ];
  const iconContent =
    typeof icon === 'string' ? <Icon name={icon} /> : icon ?? children;

  return (
    <MuiIconButton {...props} data-testid={dataTestId} sx={iconButtonSx}>
      {iconContent}
    </MuiIconButton>
  );
}

export default LelyIconButton;
